import { Backdrop, Card, CardContent, CardHeader, CircularProgress, Checkbox, Chip, Container, Divider, Grid, Snackbar, Table, TableCell, TableContainer, TableBody, TableHead, TableRow, TextField, createTheme, Switch, Typography, Button, TablePagination, Autocomplete, Stack, Tooltip } from '@mui/material';
import Alert from 'src/components/Alert';
import React, { useState, useEffect } from 'react';
import { getUser } from 'src/utils/Common';
import Page from 'src/components/Page';
import { useTheme } from '@mui/material/styles';

import trLocale from 'date-fns/locale/tr';

import axios from 'src/utils/axios';
import { PatternFormat } from 'react-number-format';
import SearchIcon from '@mui/icons-material/Search';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import ExcelFileCreator from 'src/components/ExcelFileCreator';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';


const materialTheme = createTheme({
  palette: {
    primary: {
      contrastText: '#FF9800',
      dark: '#424242',
      main: '#424242',
      light: '#424242'
    }
  }
});

const localeMap = {
  tr: trLocale
};



const styles = {
  root: (theme) => ({
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  }),
  rootlist: (theme) => ({
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    maxHeight: 550
  }),
  rootlistsag: (theme) => ({
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    maxHeight: 500
  }),

  cardBolum: {
    maxHeight: 700,
    minHeight: 700,
    width: '100%'
  },
  table: {
    minWidth: 650
  },
  content: {
    minHeight: 550
  },
  chatSection: {
    width: '100%'
  },
  avatar: {
    cursor: 'pointer',
    width: 40,
    height: 40
  },
  headBG: {
    backgroundColor: '#e0e0e0'
  },
  borderRight500: {
    borderRight: '1px solid #e0e0e0'
  },
  messageArea: {
    overflowY: 'auto'
  },
  button: (theme) => ({
    margin: theme.spacing(1)
  }),
  backdrop: (theme) => ({
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }),
  actionsCCFile: {
    justifyContent: 'flex-end'
  },
  responsiveContainer: (theme) => ({
    marginTop: theme.spacing(3),
    [theme.breakpoints.between('md', 'lg')]: {
      maxHeight: '70vh',
      overflowX: 'hidden',
      overflowY: 'scroll'
    },
    [theme.breakpoints.down('sm')]: {
      maxHeight: '60vh',
      overflow: 'scroll'
    }
  }),
  action: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    paddingLeft: '16px',
    marginRight: '10px',
    borderRadius: 10,
  },
  switch_track: {
    backgroundColor: "#263238",
  },
  switch_base: {
    color: '#FF9800',
    "&.Mui-disabled": {
      color: '#FF9800'
    },
    "&.Mui-checked": {
      color: "#FF9800"
    },
    "&.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#263238",
    }
  },
  switch_primary: {
    "&.Mui-checked": {
      color: "#263238",
    },
    "&.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#263238",
    },
  },
};

function EmployeeInformationReport() {
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const SessionUser = getUser();

  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  const [bolgeAdiKodu, setBolgeAdiKodu] = React.useState([]);
  const [BirimData, setBirimData] = React.useState([]);
  const [selectedbolgeAdiKodu, setSelectedbolgeAdiKodu] = React.useState([]);
  const [SelectedBirim, setSelectedBirim] = React.useState([]);
  const [OrganizationControl, setOrganizationControl] = React.useState(0);
  const [catalogData, setCatalogData] = useState([]);
  const [districtData, setDistrictData] = useState([]);
  const [DealerGroup, setDealerGroup] = React.useState([]);
  const [selectedDealerGroup, setselectedDealerGroup] = React.useState([]);

  const [DealerCompany, setDealerCompany] = React.useState([]);
  const [selectedDealerCompany, setSelectedDealerCompany] = React.useState([]);

  const [DealerArea, setDealerArea] = React.useState([]);
  const [selectedDealerArea, setSelectedDealerArea] = React.useState([]);

  const [salesRepDealer, setSalesRepDealer] = React.useState([]);
  const [selectedSalesRepDealer, setSelectedSalesRepDealer] = React.useState([]);

  const [Dealer, setDealer] = React.useState([]);
  const [selectedDealer, setSelectedDealer] = React.useState([]);

  const [personelType, setPersonelType] = React.useState([]);
  const [personelPhone, setPersonelPhone] = React.useState('');
  const [personelStatus, setPersonelStatus] = React.useState([]);
  const [personelEducation, setPersonelEducation] = React.useState([]);
  const [personelCity, setPersonelCity] = React.useState([]);
  const [personelDistrict, setPersonelDistrict] = React.useState([]);
  const [employeeReportData, setEmployeeReportData] = React.useState([]);
  const [pg, setpg] = React.useState(0);
  const [rpg, setrpg] = React.useState(5);

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" style={{ color: '#FF9800' }} />;
  const selectAllIcon = <PlaylistAddCheckIcon fontSize="small" />;

  const SelectAllOption = { Id: -1, Dsc: 'Tümünü Seç' };
  const SelectAllOptionForBirim = { BirimKodu: 0, Dsc: 'Tümü' };

  useEffect(() => {
    setLoading(true);
    getBolgeAdiKoduData();
    GetDealerGroupData();
    if (OrganizationControl === 0) {
      if ([2, 4, 6].includes(SessionUser.ManagementRoleId)) {
        setOrganizationControl(1);
      } else {
        setOrganizationControl(2);
      }
    }
    handleCatalog(0);
    setLoading(false);
  }, [OrganizationControl]);

  // const GetDealerData = (Area) => {
  //   axios.get(`GetDealerData/${selectedDealerGroup?.Id}/${selectedDealerCompany?.Id}/${Area}`).then((response) => {
  //     setDealer(response.data);
  //   })
  // }
  const GetDealerData = (Area, Company, Group, SalesRep) => {


    if (Company === "") {
      Company = selectedDealerCompany?.Id;
    }
    if (Group === "") {
      Group = selectedDealerGroup?.Id;
    }
    if (Area === "") {
      Area = selectedDealerArea?.Id;
    }

    axios.get(`GetDealerData/${Group}/${Company}/${Area}/${SalesRep}`).then((response) => {
      setDealer(response.data);
      if (response?.data?.length === 1) {
        setSelectedDealer(response?.data[0]);
        setPage(0);
        getDetail(response?.data[0]?.Id);
      }
    }).catch((error) => {
    });
  }

  const GetDealerAreaData = (Company) => {
    axios.get(`GetDealerAreaData/${selectedDealerGroup?.Id}/${Company}`).then((response) => {
      setDealerArea(response.data);
    })
  }

  const GetDealerCompanyData = (Group) => {
    axios.get(`GetDealerCompanyData/${Group}`).then((response) => {
      setDealerCompany(response.data);
    })

  }

  const GetDealerGroupData = () => {
    axios.get(`GetDealerGroupData`).then((response) => {
      setDealerGroup(response.data);
    })

  }

  const GetDealerSalesRepData = (Area, Company, Group) => {


    if (Company === "") {
      Company = selectedDealerCompany?.Id;
    }
    if (Group === "") {
      Group = selectedDealerGroup?.Id;
    }

    axios.get(`GetDealerSalesRepData/${Group}/${Company}/${Area}`).then((response) => {
      setDealer(response.data);
      if (response?.data?.length > 0) {
        setSalesRepDealer(response?.data);
      }
    }).catch((error) => {
    });
  }

  const getBolgeAdiKoduData = () => {
    axios.get(`GetBolgeAdiKodu/${SessionUser.TopServiceShopCode}`).then((response) => {
      setBolgeAdiKodu(response?.data);
    })

  }

  const getBirimData = (BirimKodu) => {

    if (!BirimKodu || BirimKodu.length < 1) {
      setBirimData([]);
    } else {
      setLoading(true);
      axios.get(`GetBirimDataCokBolgeli?BirimKodu=${BirimKodu.join("&BirimKodu=")}`).then((response) => {
        setBirimData([SelectAllOptionForBirim, ...response.data]);
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });
    }
  }

  const changeOrganizationControl = () => {
    setOrganizationControl(OrganizationControl === 1 ? 2 : 1);
    clearAllInputs();
  }

  const handleCatalog = (id) => {
    axios.get(`GetCatalogItemsForEmployee/${id}/${OrganizationControl}`).then((response) => {
      if (response.data.length > 0 && id == 0) {
        const res = response.data[0]
        setCatalogData(res)
      } else {
        const res = response.data
        setDistrictData(res)
      }
    }).catch(error => {
    });
  }

  const getReport = () => {
    if (((OrganizationControl === 1 && selectedbolgeAdiKodu.length < 1 && SelectedBirim.length < 1) ||
      (OrganizationControl === 2 && selectedDealerGroup.length < 1 && selectedDealerCompany.length < 1 && selectedDealerArea.length < 1 && selectedDealer.length < 1)) &&
      personelStatus.length < 1 &&
      personelType.length < 1 &&
      !personelPhone &&
      // personelBloodGroup.length < 1 &&
      personelEducation.length < 1 &&
      personelCity.length < 1 &&
      personelDistrict.length < 1) {

      setUyari(true);
      setUyariTip('warning');
      setresponseMessage('Arama yapabilmeniz için en az bir tane filtre seçmeniz gerekmektedir!..');
      return;
    }


    setLoading(true);
    var data = {
      OrganizationControl: OrganizationControl,
      TopServiceShopId: OrganizationControl === 1 && selectedbolgeAdiKodu.find((x) => x.BirimKodu == 0) ? [0]
        : selectedbolgeAdiKodu.map(x => x.BirimKodu),
      DealerGroup: new Array(selectedDealerGroup?.Id),
      DealerCompany: new Array(selectedDealerCompany?.Id),
      DealerRep: new Array(selectedSalesRepDealer?.Id),
      DealerArea: new Array(selectedDealerArea?.Id),
      ServiceShopOrDealerId: OrganizationControl === 1 && SelectedBirim.find((x) => x.BirimKodu == 0) ? [0]
        : OrganizationControl === 1 ? SelectedBirim.map(x => x.BirimKodu)
          : selectedDealer.map(x => x.Id),
      PersonelStatus: personelStatus.map(x => x.Id),
      PersonelType: personelType.map(x => x.Id),
      PersonelPhone: personelPhone.replace(/\D/g, ''),
      // PersonelBloodGroup: personelBloodGroup.map(x => x.Id),
      PersonelEducation: personelEducation.map(x => x.Id),
      PersonelDistrict: personelDistrict.map(x => x.Id),
      PersonelCity: Array.isArray(personelCity) ? personelCity.map(x => x.Id) : new Array(personelCity.Id)
    }

    axios.post(`GetEmployeeReport`, data).then((response) => {
      setEmployeeReportData([]);
      if (response.data.length > 0) {
        var reportDataTMP = response.data;
        setEmployeeReportData(reportDataTMP);
        setLoading(false);

      } else {
        setresponseMessage('Hiç data bulunamadı!...');
        setUyariTip('error');
        setUyari(true);
        setLoading(false);

      }
      //set page 1
      setpg(0);
    }).catch(error => {
      setLoading(false);
    });

  }

  function handleChangePage(event, newpage) {
    setpg(newpage);
  }

  function handleChangeRowsPerPage(event) {
    setrpg(parseInt(event.target.value, 10));
    setpg(0);
  }

  const clearAllInputs = () => {
    setSelectedbolgeAdiKodu([]);
    setSelectedBirim([]);
    setselectedDealerGroup([]);
    setSelectedDealerCompany([]);
    setSelectedDealerArea([]);
    setSelectedDealer([]);
    setPersonelStatus([]);
    setPersonelType([]);
    setPersonelEducation([]);
    setPersonelCity([]);
    setPersonelDistrict([]);
    setPersonelPhone('');
    setEmployeeReportData([]);
    setpg(0);
    setrpg(5);
  }

  const handleExportClick = () => {
    var kulBirimKoduAdi = "";
    OrganizationControl === 1 ? kulBirimKoduAdi = SelectedBirim?.Dsc : kulBirimKoduAdi = selectedDealer?.Dsc;

    var exportData = [];
    if (OrganizationControl === 1) {
      employeeReportData.map((item) => {
        exportData.push({
          'Eleman No': item.PersonelNo,
          'Bölge Kodu': item.TopServiceShopCode,
          'Bölge Adı': item.TopServiceShop,
          'Servis Kodu': item.ServiceShopCode,
          'Servis Adı': item.ServiceShop,
          'Servis Durum': item.ServiceShopStatus == 1 ? 'Aktif' : 'Pasif',
          'Servis Tipi': item.ServiceShopType,
          'Sicil No': item.SicilNo,
          'Teknisyen No': item.TechnicianCode,
          'İsim': item.Name,
          'Soyisim': item.Surname,
          'Durum': item.State ? 'Aktif' : 'Pasif',
          'Cinsiyet': item.Sex,
          'Çalışan Tipi': item.PersonelType,
          // 'Kvkk İzin': item.KvkkStatus ? 'Var' : 'Yok',
          'Fotoğraf': item.TechnicianImage,
          // 'Bölüm': item.Department,
          'TC Kimlik No': item.MernisNumber,
          'Doğum Yeri': item.BirthPlace,
          'Doğum Tarihi': item.BirthDate,
          'Email': item.Email,
          'Öğrenim': item.Education,
          'Cep Telefonu': item.CellPhone,
          'İşe İlk Giriş Tarihi': item.FirstDateofEntrance,
          'İlgili İşe Giriş Tarihi': item.DateofEntrance,
          'İşten Çıkış Tarihi': item.DateofDeparture,
          'Ayrılık Sebebi': item.DepartureReason,
          // 'Askerlik Durumu': item.MilitaryStatus,
          'KoçAilemli Olabilir': item.KocAilemStatus ? 'Evet' : 'Hayır',
          'Atama Yapılabilir': item.PersonelRandevuAtanabilir ? 'Evet' : 'Hayır',
          'Ehliyet': item.DriverLicense,
          'Üst Giyim Bedeni': item.UstGiyim,
          'Pantolon Bedeni': item.Pantolon,
          'Ayakkabı Numarası': item.Ayakkabi,
          'Doğum Günü İletişim İzni': item.BirthdayContactPermission,
          'İş Yıl Dönümü İletişim İzni': item.BusinessAnniversaryContactPermission,
          'Bayram Ve Özel Günler İletişim İzni': item.CelebrationContactPermission,
          'İl': item.City,
          'İlçe': item.District,
          'Adres': item.Adress,
          'Acıklama': item.Description
        })
      })
    } else {
      employeeReportData.map((item) => {
        exportData.push({
          'Eleman No': item.PersonelNo,
          'Direktörlük': item.GroupName,
          'Şube Adı': item.CompanyName,
          'Bölge Adı': item.RegionName,
          'Satış Temsilcisi': item.SalesPerson,
          'Bayi Adı': item.ServiceShop,
          'Sicil No': item.SicilNo,
          // 'Teknisyen No': item.TechnicianCode,
          'İsim': item.Name,
          'Soyisim': item.Surname,
          'Durum': item.State ? 'Aktif' : 'Pasif',
          // 'Cinsiyet': item.Sex,
          'Çalışan Tipi': item.PersonelType,
          // 'Kvkk İzin': item.KvkkStatus ? 'Var' : 'Yok',
          'Fotoğraf': item.TechnicianImage,
          // 'Bölüm': item.Department,
          'TC Kimlik No': item.MernisNumber,
          'Doğum Yeri': item.BirthPlace,
          'Doğum Tarihi': item.BirthDate,
          'Email': item.Email,
          'Öğrenim': item.Education,
          'Cep Telefonu': item.CellPhone,
          'İşe İlk Giriş Tarihi': item.FirstDateofEntrance,
          'İlgili İşe Giriş Tarihi': item.DateofEntrance,
          'İşten Çıkış Tarihi': item.DateofDeparture,
          'Ayrılık Sebebi': item.DepartureReason,
          // 'Askerlik Durumu': item.MilitaryStatus,
          'KoçAilemli Olabilir': item.KocAilemStatus ? 'Evet' : 'Hayır',
          'Atama Yapılabilir': item.PersonelRandevuAtanabilir ? 'Evet' : 'Hayır',
          'Ehliyet': item.DriverLicense,
          'Kısa Kol Tişört Bedeni': item.KisaKolTshirt,
          'Uzun Kol Tişört Bedeni': item.UzunKolTshirt,
          'Hırka Bedeni': item.Hirka,
          'Yelek Bedeni': item.Yelek,
          'Doğum Günü İletişim İzni': item.BirthdayContactPermission,
          'İş Yıl Dönümü İletişim İzni': item.BusinessAnniversaryContactPermission,
          'Bayram Ve Özel Günler İletişim İzni': item.CelebrationContactPermission,
          'Duyurular İzni': item.AnnouncementContactPermission,
          'İl': item.City,
          'İlçe': item.District,
          'Adres': item.Adress,
          'Acıklama': item.Description
        })
      })
    }

    ExcelFileCreator(exportData, `Çalışan Bilgileri Raporu`);
  };

  const renderOption = (props, option, { selected }) => (
    option.Id == -1 ? (<li {...props}>
      <Checkbox
        icon={selectAllIcon}
        checkedIcon={selectAllIcon}
        style={{ marginRight: 8 }}
        checked={selected}
      />
      {option.Dsc}
    </li>) :
      (<li {...props}>
        <Checkbox
          icon={icon}
          checkedIcon={checkedIcon}
          style={{ marginRight: 8 }}
          checked={selected}
        />
        {option.Dsc}
      </li>)
  );

  const renderOptionForBirim = (props, option, { selected }) => (
    <li {...props}>
      <Checkbox
        icon={icon}
        checkedIcon={checkedIcon}
        style={{ marginRight: 8 }}
        checked={selected}
      />
      {option.Dsc}
    </li>
  );





  return (
    <Page sx={styles.root}>
      <Backdrop sx={styles.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={uyari}
        autoHideDuration={10000}
        onClose={uyariKapat}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={uyariKapat} variant={uyariTip} message={responseMessage}
        ></Alert>
      </Snackbar>
      <Container style={styles.container1} maxWidth="xl">
        <Card>
          <CardHeader title="Çalışan Bilgileri" />
          <Divider />
          <CardContent>
            <Grid container spacing={2}>
              <Grid size={6}>
                <Stack direction="row" spacing={0} alignItems="center">
                  {[1, 2, 4, 6].includes(SessionUser?.ManagementRoleId) && (
                    <Typography>Yetkili Servis</Typography>
                  )}
                  <Switch
                    checked={OrganizationControl === 1 ? false : true}
                    sx={{
                      '& .MuiSwitch-track': styles.switch_track,
                      '& .MuiSwitch-switchBase': styles.switch_base,
                      '& .MuiSwitch-colorPrimary': styles.switch_primary,
                    }}
                    onChange={changeOrganizationControl}
                    disabled={SessionUser?.ManagementRoleId === 1 ? false : true}
                  />
                  {[1, 3, 5, 7].includes(SessionUser?.ManagementRoleId) && (
                    <Typography>Bayi</Typography>
                  )}
                </Stack>
              </Grid>
              <Grid size={6}>
                <Stack direction="row" spacing={1} justifyContent="flex-end" alignItems="center">
                  <Tooltip title="Filtreleri temizle">
                    <Button
                      variant="outlined"
                      color="secondary"
                      style={{ textTransform: 'none' }}
                      startIcon={<RestartAltIcon />}
                      onClick={clearAllInputs}
                    >
                      Temizle
                    </Button>
                  </Tooltip>
                  <Tooltip title="Seçili filtrelerle ara">
                    <Button
                      sx={styles.action}
                      variant="contained"
                      color="secondary"
                      onClick={() => {
                        getReport();
                      }}
                    >
                      ARA
                      <SearchIcon style={{ marginLeft: '5px' }} />
                    </Button>
                  </Tooltip>
                  <Tooltip title="Sonuçları Excel dosyası olarak indir">
                    <Button
                      sx={styles.action}
                      variant="contained"
                      color="secondary"
                      disabled={employeeReportData.length === 0}
                      onClick={() => {
                        handleExportClick();
                      }}
                      style={{ marginRight: '5px' }} // Add margin to the right
                    >
                      EXCEL&apos;E AKTAR
                      <FileDownloadIcon style={{ marginLeft: '5px' }} />
                    </Button>
                  </Tooltip>
                </Stack>
              </Grid>
              <Grid
                style={{ display: OrganizationControl == 1 ? 'block' : 'none' }}
                size={{ xs: 12 }}>
                <Typography variant="caption" color="text.secondary">Yetkili Servis Filtreleri</Typography>
                <Divider sx={{ mb: 1 }} />
              </Grid>
              <Grid
                style={{ display: OrganizationControl == 1 ? 'block' : 'none' }}
                size={{
                  xs: 12,
                  sm: 12,
                  lg: 6
                }}>
                {/* <Autocomplete
                  size={"small"}
                  id="combo-box-demo"
                  fullWidth
                  value={selectedbolgeAdiKodu}
                  options={bolgeAdiKodu}
                  getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                  onChange={(event, newValue) => {
                    setSelectedbolgeAdiKodu(newValue);
                    getBirimData(newValue?.BirimKodu);
                    setSelectedBirim([])
                  }}
                  renderInput={(params) => <TextField {...params} label="Bölge" variant="outlined" />}

                /> */}

                <Autocomplete
                  multiple
                  size="small"
                  id="combo-box-demo"
                  fullWidth
                  value={selectedbolgeAdiKodu}
                  options={bolgeAdiKodu.length > 0 ? bolgeAdiKodu : []}
                  getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                  renderOption={renderOptionForBirim}
                  onChange={(event, newValue) => {
                    setSelectedbolgeAdiKodu(newValue);
                    var bolgeKodu = newValue?.find(x => x.BirimKodu == '0') ? bolgeAdiKodu.map(x => x.BirimKodu) : newValue.map(x => x.BirimKodu);
                    getBirimData(bolgeKodu);
                    setSelectedBirim([])
                  }}
                  renderTags={(tagValue, getTagProps) => {
                    if (bolgeAdiKodu.length > 0 && tagValue.length === bolgeAdiKodu.length) {
                      return <Chip size="small" label={`Tümü (${tagValue.length})`} {...getTagProps({ index: 0 })} />;
                    }
                    const visibleCount = 1;
                    return (
                      <>
                        {tagValue.slice(0, visibleCount).map((option, index) => (
                          <Chip size="small" key={option.BirimKodu} label={option.Dsc} {...getTagProps({ index })} />
                        ))}
                        {tagValue.length > visibleCount && (
                          <Chip size="small" variant="outlined" label={`+${tagValue.length - visibleCount}`} />
                        )}
                      </>
                    );
                  }}
                  renderInput={(params) => <TextField {...params} label="Bölge" variant="outlined" />}
                />
              </Grid>
              <Grid
                style={{ display: OrganizationControl == 1 ? 'block' : 'none' }}
                size={{
                  xs: 12,
                  sm: 12,
                  lg: 6
                }}>
                <Autocomplete
                  multiple
                  size="small"
                  id="combo-box-demo"
                  fullWidth
                  value={SelectedBirim}
                  options={BirimData.length > 0 ? BirimData : []}
                  getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                  renderOption={renderOptionForBirim}
                  onChange={(event, newValue) => {
                    setSelectedBirim(newValue);
                  }}
                  renderTags={(tagValue, getTagProps) => {
                    if (BirimData.length > 0 && tagValue.length === BirimData.length) {
                      return <Chip size="small" label={`Tümü (${tagValue.length})`} {...getTagProps({ index: 0 })} />;
                    }
                    const visibleCount = 1;
                    return (
                      <>
                        {tagValue.slice(0, visibleCount).map((option, index) => (
                          <Chip size="small" key={option.BirimKodu} label={option.Dsc} {...getTagProps({ index })} />
                        ))}
                        {tagValue.length > visibleCount && (
                          <Chip size="small" variant="outlined" label={`+${tagValue.length - visibleCount}`} />
                        )}
                      </>
                    );
                  }}
                  renderInput={(params) => <TextField {...params} label="Servis" variant="outlined" />}

                />
              </Grid>
              <Grid
                style={{ display: OrganizationControl == 2 ? 'block' : 'none' }}
                size={{ xs: 12 }}>
                <Typography variant="caption" color="text.secondary">Bayi Filtreleri</Typography>
                <Divider sx={{ mb: 1 }} />
              </Grid>
              <Grid
                style={{ display: OrganizationControl == 2 ? 'block' : 'none' }}
                size={{
                  xs: 12,
                  sm: 12,
                  lg: 2
                }}>
                <Autocomplete
                  size="small"
                  id="combo-box-demo"
                  fullWidth
                  value={selectedDealerGroup}
                  options={DealerGroup}
                  getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                  onChange={(event, newValue) => {
                    setselectedDealerGroup(newValue);
                    GetDealerCompanyData(newValue?.Id);
                    setSelectedDealerCompany([]);
                    setSelectedDealerArea([]);
                    setSelectedSalesRepDealer([]);
                    setSelectedDealer([]);
                    setDealer([]);
                  }}
                  renderInput={(params) => <TextField {...params} label="Grup" variant="outlined" />}
                />
              </Grid>
              <Grid
                style={{ display: OrganizationControl == 2 ? 'block' : 'none' }}
                size={{
                  xs: 12,
                  sm: 12,
                  lg: 2
                }}>
                <Autocomplete
                  size="small"
                  id="combo-box-demo"
                  fullWidth
                  value={selectedDealerCompany}
                  options={DealerCompany}
                  getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                  onChange={(event, newValue) => {
                    setSelectedDealerCompany(newValue);
                    GetDealerAreaData(newValue?.Id);
                    setSelectedDealerArea([]);
                    setSelectedDealer([]);
                    setSelectedSalesRepDealer([]);
                    setDealer([]);

                  }}
                  renderInput={(params) => <TextField {...params} label="Şirket" variant="outlined" />}
                />
              </Grid>
              <Grid
                style={{ display: OrganizationControl == 2 ? 'block' : 'none' }}
                size={{
                  xs: 12,
                  sm: 12,
                  lg: 2
                }}>
                <Autocomplete
                  size="small"
                  id="combo-box-demo"
                  fullWidth
                  value={selectedDealerArea}
                  options={DealerArea}
                  getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                  onChange={(event, newValue) => {
                    setSelectedDealerArea(newValue);
                    GetDealerSalesRepData(newValue?.Id, "", "");
                    setSelectedSalesRepDealer([]);
                    setSelectedDealer([]);
                  }}
                  renderInput={(params) => <TextField {...params} label="Bölge" variant="outlined" />}
                />
              </Grid>
              <Grid
                style={{ display: OrganizationControl == 2 ? 'block' : 'none' }}
                size={{
                  xs: 12,
                  sm: 12,
                  lg: 2
                }}>
                <Autocomplete
                  size="small"
                  id="combo-box-demo"
                  fullWidth
                  value={selectedSalesRepDealer}
                  options={salesRepDealer}
                  getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                  onChange={(event, newValue) => {
                    setSelectedSalesRepDealer(newValue);
                    GetDealerData("", "", "", newValue?.Id);
                  }}

                  renderInput={(params) => <TextField {...params} label="Satış Temsilcisi" variant="outlined"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />}
                />
              </Grid>
              <Grid
                style={{ display: OrganizationControl == 2 ? 'block' : 'none' }}
                size={{
                  xs: 12,
                  sm: 12,
                  lg: 4
                }}>
                <Autocomplete
                  multiple
                  size="small"
                  id="combo-box-demo"
                  fullWidth
                  value={selectedDealer}
                  options={Dealer.length > 0 ? Dealer : []}
                  getOptionLabel={(option) => { return option.Id ? (option.Id + ' - ' + option.Dsc) : '-' }}
                  renderOption={renderOption}
                  onChange={(event, newValue) => {
                    newValue?.find(x => x.Id == -1) ? setSelectedDealer(Dealer) : setSelectedDealer(newValue);
                  }}
                  renderTags={(tagValue, getTagProps) => {
                    if (Dealer.length > 0 && tagValue.length === Dealer.length) {
                      return <Chip size="small" label={`Tümü (${tagValue.length})`} {...getTagProps({ index: 0 })} />;
                    }
                    const visibleCount = 1;
                    return (
                      <>
                        {tagValue.slice(0, visibleCount).map((option, index) => (
                          <Chip size="small" key={option.Id} label={option.Id ? `${option.Id} - ${option.Dsc}` : '-'} {...getTagProps({ index })} />
                        ))}
                        {tagValue.length > visibleCount && (
                          <Chip size="small" variant="outlined" label={`+${tagValue.length - visibleCount}`} />
                        )}
                      </>
                    );
                  }}
                  renderInput={(params) => <TextField {...params} label="Bayi" variant="outlined" />}
                />
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  sm: 12,
                  lg: 4
                }}>
                <Autocomplete
                  multiple
                  options={catalogData?.CalisanDurum ? [SelectAllOption, ...catalogData?.CalisanDurum] : []}
                  value={personelStatus}
                  getOptionLabel={(i) => i.Dsc}
                  renderOption={renderOption}
                  onChange={(event, val) => {
                    val.find(x => x.Id == -1) ? setPersonelStatus(catalogData?.CalisanDurum) : setPersonelStatus(val)
                  }}
                  renderTags={(tagValue, getTagProps) => {
                    const total = catalogData?.CalisanDurum?.length || 0;
                    if (total > 0 && tagValue.length === total) {
                      return <Chip size="small" label={`Tümü (${tagValue.length})`} {...getTagProps({ index: 0 })} />;
                    }
                    const visibleCount = 1;
                    return (
                      <>
                        {tagValue.slice(0, visibleCount).map((option, index) => (
                          <Chip size="small" key={option.Id} label={option.Dsc} {...getTagProps({ index })} />
                        ))}
                        {tagValue.length > visibleCount && (
                          <Chip size="small" variant="outlined" label={`+${tagValue.length - visibleCount}`} />
                        )}
                      </>
                    );
                  }}
                  renderInput={(params) => <TextField {...params} label="Çalışan Durum" variant="outlined" />}
                  fullWidth
                  size="small"
                />
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  sm: 12,
                  lg: 4
                }}>
                <Autocomplete
                  multiple
                  options={catalogData?.CalisanTip ? [SelectAllOption, ...catalogData?.CalisanTip] : []}
                  value={personelType}
                  getOptionLabel={(i) => i.Dsc}
                  renderOption={renderOption}
                  onChange={(event, val) => {
                    val.find(x => x.Id == -1) ? setPersonelType(catalogData?.CalisanTip) : setPersonelType(val)
                  }}
                  renderTags={(tagValue, getTagProps) => {
                    const total = catalogData?.CalisanTip?.length || 0;
                    if (total > 0 && tagValue.length === total) {
                      return <Chip size="small" label={`Tümü (${tagValue.length})`} {...getTagProps({ index: 0 })} />;
                    }
                    const visibleCount = 1;
                    return (
                      <>
                        {tagValue.slice(0, visibleCount).map((option, index) => (
                          <Chip size="small" key={option.Id} label={option.Dsc} {...getTagProps({ index })} />
                        ))}
                        {tagValue.length > visibleCount && (
                          <Chip size="small" variant="outlined" label={`+${tagValue.length - visibleCount}`} />
                        )}
                      </>
                    );
                  }}
                  renderInput={(params) => <TextField {...params} label="Çalışan Tipi" variant="outlined" />}
                  fullWidth
                  size="small"
                />
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  sm: 12,
                  lg: 4
                }}>
                <PatternFormat
                  format="(###) ###-####"
                  mask="_"
                  fullWidth
                  size="small"
                  value={personelPhone}
                  customInput={TextField}
                  label="Cep Telefonu"
                  placeholder='(___) __-____'
                  variant='outlined'
                  onChange={(e) => setPersonelPhone(e.target.value)}
                />
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  sm: 12,
                  lg: 4
                }}>
                <Autocomplete
                  multiple
                  options={catalogData?.OgrenimDurumu ? [SelectAllOption, ...catalogData?.OgrenimDurumu] : []}
                  value={personelEducation}
                  getOptionLabel={(option) => option.Dsc}
                  renderOption={renderOption}
                  onChange={(event, val) => {
                    val.find(x => x.Id == -1) ? setPersonelEducation(catalogData?.OgrenimDurumu) : setPersonelEducation(val)
                  }}
                  renderTags={(tagValue, getTagProps) => {
                    const total = catalogData?.OgrenimDurumu?.length || 0;
                    if (total > 0 && tagValue.length === total) {
                      return <Chip size="small" label={`Tümü (${tagValue.length})`} {...getTagProps({ index: 0 })} />;
                    }
                    const visibleCount = 1;
                    return (
                      <>
                        {tagValue.slice(0, visibleCount).map((option, index) => (
                          <Chip size="small" key={option.Id} label={option.Dsc} {...getTagProps({ index })} />
                        ))}
                        {tagValue.length > visibleCount && (
                          <Chip size="small" variant="outlined" label={`+${tagValue.length - visibleCount}`} />
                        )}
                      </>
                    );
                  }}
                  fullWidth
                  renderInput={(params) => <TextField {...params} label="Öğrenim" variant="outlined" />}
                  size="small"
                />
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  sm: 12,
                  lg: 4
                }}>
                <Autocomplete
                  size="small"
                  options={catalogData?.IL || []}
                  value={personelCity}
                  getOptionLabel={(i) => i.Dsc || ''}
                  onChange={(event, val) => {
                    handleCatalog(val.Id);
                    setPersonelCity(val);
                    setPersonelDistrict([]);
                  }}
                  fullWidth
                  renderInput={(params) => <TextField {...params} label="Il" variant="outlined"
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: 'new-password', // disable autocomplete and autofill
                    }} />}
                />

              </Grid>
              <Grid
                size={{
                  xs: 12,
                  sm: 12,
                  lg: 4
                }}>
                <Autocomplete
                  multiple
                  size="small"
                  options={districtData.length > 0 ? [SelectAllOption, ...districtData] : []}
                  value={personelDistrict}
                  getOptionLabel={(i) => i.Dsc}
                  renderOption={renderOption}
                  onChange={(event, val) => {
                    val.find(x => x.Id == -1) ? setPersonelDistrict(districtData) : setPersonelDistrict(val)
                  }}
                  renderTags={(tagValue, getTagProps) => {
                    if (districtData.length > 0 && tagValue.length === districtData.length) {
                      return <Chip size="small" label={`Tümü (${tagValue.length})`} {...getTagProps({ index: 0 })} />;
                    }
                    const visibleCount = 1;
                    return (
                      <>
                        {tagValue.slice(0, visibleCount).map((option, index) => (
                          <Chip size="small" key={option.Id} label={option.Dsc} {...getTagProps({ index })} />
                        ))}
                        {tagValue.length > visibleCount && (
                          <Chip size="small" variant="outlined" label={`+${tagValue.length - visibleCount}`} />
                        )}
                      </>
                    );
                  }}
                  fullWidth
                  renderInput={(params) => <TextField {...params} label="İlçe" variant="outlined"
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: 'new-password', // disable autocomplete and autofill
                    }} />}
                />
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  sm: 12,
                  lg: 12
                }}>
                <TableContainer sx={{ maxHeight: 560, overflow: 'auto' }}>
                  <Table stickyHeader aria-label="sticky table" size="small">
                    <TableHead style={{ overflowWrap: 'break-word' }}>
                      <TableRow>
                        <TableCell align="left" sx={{ position: 'sticky', left: 0, zIndex: 3, backgroundColor: 'background.paper' }}>Eleman No</TableCell>
                        {OrganizationControl === 1 ? (
                          <>
                            <TableCell align="left">Bölge Kodu</TableCell>
                            <TableCell align="left">Bölge Adı</TableCell>
                            <TableCell align="left">Servis Kodu</TableCell>
                            <TableCell align="left">Servis Adı</TableCell>
                            <TableCell align="left">Servis Durum</TableCell>
                            <TableCell align="left">Servis Tipi</TableCell>
                            <TableCell align="left">Teknisyen No</TableCell>
                            <TableCell align="left">Cinsiyet</TableCell>

                          </>) : <>
                          <TableCell align="left">Direktörlük</TableCell>
                          <TableCell align="left">Şube Adı</TableCell>
                          <TableCell align="left">Bölge Adı</TableCell>
                          <TableCell align="left">Satış Temsilcisi</TableCell>
                          <TableCell align="left">Bayi Adı</TableCell>
                        </>}
                        <TableCell align="left">Sicil No</TableCell>
                        <TableCell align="left">İsim</TableCell>
                        <TableCell align="left">Soyisim</TableCell>
                        <TableCell align="left">Durum</TableCell>

                        <TableCell align="left">Çalışan Tipi</TableCell>
                        {/* <TableCell align="left">Kvkk İzin</TableCell> */}
                        <TableCell align="left">Fotoğraf</TableCell>
                        {/* <TableCell align="left">Bölüm</TableCell> */}
                        <TableCell align="left">TC Kimlik No</TableCell>
                        <TableCell align="left">Doğum Yeri</TableCell>
                        <TableCell align="left">Doğum Tarihi</TableCell>
                        <TableCell align="left">Email</TableCell>
                        <TableCell align="left">Öğrenim</TableCell>
                        <TableCell align="left">Cep Telefonu</TableCell>
                        <TableCell align="left">İşe İlk Giriş Tarihi</TableCell>
                        <TableCell align="left">İlgili İşe Giriş Tarihi</TableCell>
                        <TableCell align="left">İşten Çıkış Tarihi</TableCell>
                        <TableCell align="left">Ayrılık Sebebi</TableCell>
                        {/* <TableCell align="left">Askerlik Durumu</TableCell> */}
                        <TableCell align="left">KoçAilemli Olabilir</TableCell>
                        <TableCell align="left">Atama Yapılabilir</TableCell>
                        <TableCell align="left">Ehliyet</TableCell>
                        {OrganizationControl === 1 ? <><TableCell align="left">Üst Giyim</TableCell>
                          <TableCell align="left">Pantolon</TableCell>
                          <TableCell align="left">Ayakkabı</TableCell>
                        </>
                          : <><TableCell align="left">Kısa Kol Tişört</TableCell>
                            <TableCell align="left">Uzun Kol Tişört</TableCell>
                            <TableCell align="left">Hırka</TableCell>
                            <TableCell align="left">Yelek</TableCell></>}
                        <TableCell align="left">İl</TableCell>
                        <TableCell align="left">İlçe</TableCell>
                        <TableCell align="left">Adres</TableCell>
                        <TableCell align="left">Açıklama</TableCell>
                        <TableCell align="left">Doğum Günü İletişim İzni</TableCell>
                        <TableCell align="left">İş Yıl Dönümü İletişim İzni</TableCell>
                        <TableCell align="left">Bayram Ve Özel Günler İletişim İzni</TableCell>
                        {OrganizationControl === 2 ? <>
                          <TableCell align="left">Duyurular İzni</TableCell>
                        </> : <></>}
                        <TableCell align="left" />
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {employeeReportData.length > 0 && employeeReportData.slice(pg * rpg, pg * rpg + rpg).map((row, index) => (
                        <TableRow
                          key={row.Id}
                          sx={{
                            '&:nth-of-type(odd)': { backgroundColor: 'action.hover' },
                            '&:nth-of-type(odd) .sticky-col': { backgroundColor: 'action.hover' }
                          }}
                        >
                          <TableCell align="left" className="sticky-col" sx={{ position: 'sticky', left: 0, zIndex: 1, backgroundColor: 'background.paper' }}>{row.PersonelNo || "-"}</TableCell>
                          {OrganizationControl === 1 ? (
                            <>
                              <TableCell align="left">{row.TopServiceShopCode || "-"}</TableCell>
                              <TableCell align="left">{row.TopServiceShop || "-"}</TableCell>
                              <TableCell align="left">{row.ServiceShopCode || "-"}</TableCell>
                              <TableCell align="left">{row.ServiceShop || "-"}</TableCell>
                              <TableCell align="left">{row.ServiceShopStatus == 1 ? 'Aktif' : 'Pasif'}</TableCell>
                              <TableCell align="left">{row.ServiceShopType || "-"}</TableCell>
                              <TableCell align="left">{row.TechnicianCode || "-"}</TableCell>
                              <TableCell align="left">{row.Sex || "-"}</TableCell>
                            </>) : <>
                            <TableCell align="left">{row.GroupName || "-"}</TableCell>
                            <TableCell align="left">{row.CompanyName || "-"}</TableCell>
                            <TableCell align="left">{row.RegionName || "-"}</TableCell>
                            <TableCell align="left">{row.SalesPerson || "-"}</TableCell>
                            <TableCell align="left">{row.ServiceShop || "-"}</TableCell>
                          </>}
                          <TableCell align="left">{row.SicilNo || "-"}</TableCell>

                          <TableCell align="left">{row.Name || "-"}</TableCell>
                          <TableCell align="left">{row.Surname || "-"}</TableCell>
                          <TableCell align="left">{row.State ? 'Çalışıyor' : 'Çalışmıyor'}</TableCell>

                          <TableCell align="left">{row.PersonelType || "-"}</TableCell>
                          {/* <TableCell align="left">{row.KvkkStatus ? 'Var' : 'Yok'}</TableCell> */}
                          <TableCell align="left">{row.TechnicianImage || "-"}</TableCell>
                          {/* <TableCell align="left">{row.Department || "-"}</TableCell> */}
                          <TableCell align="left">{row.MernisNumber || "-"}</TableCell>
                          <TableCell align="left">{row.BirthPlace || "-"}</TableCell>
                          <TableCell align="left">{row.BirthDate || "-"}</TableCell>
                          <TableCell align="left">{row.Email || "-"}</TableCell>
                          <TableCell align="left">{row.Education || "-"}</TableCell>
                          <TableCell align="left">{row.CellPhone || "-"}</TableCell>
                          <TableCell align="left">{row.FirstDateofEntrance || "-"}</TableCell>
                          <TableCell align="left">{row.DateofEntrance || "-"}</TableCell>
                          <TableCell align="left">{row.DateofDeparture || "-"}</TableCell>
                          <TableCell align="left">{row.DepartureReason || "-"}</TableCell>
                          {/* <TableCell align="left">{row.MilitaryStatus}</TableCell> */}
                          <TableCell align="left">{row.KocAilemStatus ? 'Evet' : 'Hayır'}</TableCell>
                          <TableCell align="left">{row.PersonelRandevuAtanabilir ? 'Evet' : 'Hayır'}</TableCell>
                          <TableCell align="left">{row.DriverLicense}</TableCell>
                          {OrganizationControl === 1 ? <>
                            <TableCell align="left">{row.UstGiyim || "-"}</TableCell>
                            <TableCell align="left">{row.Pantolon || "-"}</TableCell>
                            <TableCell align="left">{row.Ayakkabi || "-"}</TableCell>
                          </>
                            : <><TableCell align="left">{row.KisaKolTshirt || "-"}</TableCell>
                              <TableCell align="left">{row.UzunKolTshirt || "-"}</TableCell>
                              <TableCell align="left">{row.Hirka || "-"}</TableCell>
                              <TableCell align="left">{row.Yelek || "-"}</TableCell></>}
                          <TableCell align="left">{row.City || "-"}</TableCell>
                          <TableCell align="left">{row.District || "-"}</TableCell>
                          <TableCell align="left">{row.Address || "-"}</TableCell>
                          <TableCell align="left">{row.Description || "-"}</TableCell>
                          <TableCell align="left">{row.BirthdayContactPermission || "-"}</TableCell>
                          <TableCell align="left">{row.BusinessAnniversaryContactPermission || "-"}</TableCell>
                          <TableCell align="left">{row.CelebrationContactPermission || "-"}</TableCell>
                          {OrganizationControl === 2 ? <>
                            <TableCell align="left">{row.AnnouncementContactPermission || "-"}</TableCell>
                          </> : <></>}
                          <TableCell align="left" />
                        </TableRow>
                      ))}

                    </TableBody>

                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </CardContent>
          {employeeReportData.length > 0 &&
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={employeeReportData.length}
              rowsPerPage={rpg}
              page={pg}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          }
        </Card>
      </Container>
    </Page >
  );
}
export default EmployeeInformationReport;
